module.exports = __webpack_public_path__ + "assets/img/rig.e48342f2.png";